package fr.frux.shared.data.local

import fr.frux.core.database.FruxDatabase
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

/**
 * Favoris sur SQLDelight (#61). Contrairement à [SqlDelightTreeLocalDataSource], l'appelant
 * ([fr.frux.shared.data.favorites.FavoritesStoreImpl]) vit sur le thread principal : les accès
 * bloquants basculent ici sur [dispatcher].
 */
class SqlDelightFavoriteLocalDataSource(
    private val database: FruxDatabase,
    private val dispatcher: CoroutineDispatcher,
) : FavoriteLocalDataSource {
    override suspend fun favoriteIds(): Set<Long> =
        withContext(dispatcher) {
            database.favoriteQueries
                .selectAll()
                .executeAsList()
                .toSet()
        }

    override suspend fun setFavorite(
        treeId: Long,
        isFavorite: Boolean,
    ) {
        withContext(dispatcher) {
            if (isFavorite) {
                database.favoriteQueries.insert(treeId)
            } else {
                database.favoriteQueries.delete(treeId)
            }
        }
    }

    override suspend fun replaceAll(ids: Set<Long>) =
        withContext(dispatcher) {
            database.favoriteQueries.transaction {
                database.favoriteQueries.clearAll()
                ids.forEach { database.favoriteQueries.insert(it) }
            }
        }

    override suspend fun clear() {
        withContext(dispatcher) {
            database.favoriteQueries.clearAll()
        }
    }
}
